export default __webpack_public_path__ + "static/media/b_3.a5676f91.jpg";